import { render, staticRenderFns } from "./CaseUpdateStatusModal.vue?vue&type=template&id=55ac4490&scoped=true"
import script from "./CaseUpdateStatusModal.vue?vue&type=script&lang=js"
export * from "./CaseUpdateStatusModal.vue?vue&type=script&lang=js"
import style0 from "./CaseUpdateStatusModal.vue?vue&type=style&index=0&id=55ac4490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac4490",
  null
  
)

export default component.exports